import { EFeatureFlag } from "@frontend-shared/constants";

import { useFeatureFlag } from "@/hooks/use-feature-flag";

// NOTE: Gate semantics —
//   `CALL_ASSISTANT_FEATURES_ENABLED=true`  → show for everyone (no opt-in needed).
//   `_ENABLED=false`, `_FF=true` → backend serves the endpoint, but
//     the UI stays hidden until the user opts in via localStorage.
//   Otherwise → hidden.
// The backend guard mirrors this: it allows the API through when
// EITHER flag is true (see call-assistant-features.guard.ts), so the
// localStorage opt-in path actually has data to render.
// NSAI-1249 — resolved from the shared registry so the mobile app gates the
// Call Assistant on exactly the same two server flags and the same opt-in key.
export const useCallAssistantFeaturesEnabled = (): boolean =>
  useFeatureFlag(EFeatureFlag.CALL_ASSISTANT_FEATURES);
